module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "slider-about-us-team"
  }, [_c('div', {
    staticClass: "slider-about-us-team__container"
  }, [_c('div', {
    staticClass: "slider-about-us-team__title"
  }, [_vm._v(_vm._s(_vm.props.title))]), _c('div', {
    staticClass: "slider-about-us-team__bottom"
  }, [_c('div', {
    staticClass: "slider-about-us-team__cards"
  }, _vm._l((_vm.props.members), function(card, j) {
    return _c('div', {
      staticClass: "slider-about-us-team__card",
      class: {
        'slider-about-us-team__card--active': j === 1
      },
      attrs: {
        "id": 'card-' + j
      }
    }, [_c('div', {
      staticClass: "slider-about-us-team__card-image",
      style: ({
        backgroundImage: 'url(' + card.photo + ')'
      })
    }), _c('div', {
      staticClass: "slider-about-us-team__card-content"
    }, [_c('div', {
      staticClass: "slider-about-us-team__name"
    }, [_vm._v(_vm._s(card.name))]), _c('div', {
      staticClass: "slider-about-us-team__position"
    }, [_vm._v(_vm._s(card.position))]), _c('div', {
      staticClass: "slider-about-us-team__bio",
      domProps: {
        "innerHTML": _vm._s(card.bio)
      }
    })])])
  }), 0)]), _c('div', {
    staticClass: "slider-about-us-team__top"
  }, [_c('div', {
    directives: [{
      name: "slider-about-us-team-directive",
      rawName: "v-slider-about-us-team-directive"
    }],
    staticClass: "slider-about-us-team__slides"
  }, _vm._l((_vm.props.members), function(slide, i) {
    return _c('div', {
      staticClass: "slider-about-us-team__slide"
    }, [_c('div', {
      staticClass: "slider-about-us-team__slide-content",
      class: {
        'zero': i === 0
      },
      style: ({
        backgroundImage: 'url(' + slide.photo + ')'
      }),
      attrs: {
        "id": 'slide-' + i
      }
    }), (_vm.active) ? _c('div', {
      staticClass: "slider-about-us-team__slide-content slider-about-us-team__slide-content--option"
    }, [_vm._v(_vm._s(slide.photo_1))]) : _vm._e()])
  }), 0)]), _c('div', {
    staticClass: "slider-about-us-team__mobile"
  }, [_c('div', {
    directives: [{
      name: "slider-about-us-team-mobile-directive",
      rawName: "v-slider-about-us-team-mobile-directive"
    }],
    staticClass: "slider-about-us-team__cards-mobile"
  }, _vm._l((_vm.props.members), function(card, k) {
    return _c('div', {
      staticClass: "slider-about-us-team__card-mobile",
      class: {
        'slider-about-us-team__card--active': k === 1
      },
      attrs: {
        "id": 'card-' + k
      }
    }, [_c('div', {
      staticClass: "slider-about-us-team__card-image-mobile",
      style: ({
        backgroundImage: 'url(' + card.photo + ')'
      })
    }), _c('div', {
      staticClass: "slider-about-us-team__card-content-mobile"
    }, [_c('div', {
      staticClass: "slider-about-us-team__name"
    }, [_vm._v(_vm._s(card.name))]), _c('div', {
      staticClass: "slider-about-us-team__position"
    }, [_vm._v(_vm._s(card.position))]), _c('div', {
      staticClass: "slider-about-us-team__bio",
      domProps: {
        "innerHTML": _vm._s(card.bio)
      }
    })])])
  }), 0)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d7aaba1","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/slider/slider-about-us-team/slider-about-us-team.pug
// module id = 588
// module chunks = 1